// src/pages/Checkout.tsx

import React, { useEffect } from "react";
import CheckoutComponent from "@/components/Checkout/Checkout";

const Checkout: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <title>Checkout – HIXA – DSG Getriebe Reparatur & Wartung</title>
      <link rel="icon" href="/images/favicon.ico" type="image/x-icon" />
      <CheckoutComponent />
    </>
  );
};

export default Checkout;
